module.exports = __webpack_public_path__ + "img/KeyboardHands.5064d0d7.jpg";